import global from './Globals';

export default {
  fontColour: global.white,
  editText: global.grey500,
};
